import { cn } from "@/lib/utils";
import type { LucideIcon } from "lucide-react";

export interface SegmentedControlItem {
  id: string;
  icon: LucideIcon;
  label: string;
}

interface SegmentedControlProps {
  items: SegmentedControlItem[];
  activeId: string;
  onSelect: (id: string) => void;
  className?: string;
}

export function SegmentedControl({
  items,
  activeId,
  onSelect,
  className,
}: SegmentedControlProps) {
  return (
    <div
      className={cn(
        "flex items-center bg-secondary/50 rounded-xl border border-border p-1 w-full max-w-md mx-auto",
        className
      )}
    >
      {items.map((item) => {
        const Icon = item.icon;
        const isActive = item.id === activeId;
        return (
          <button
            key={item.id}
            onClick={isActive ? undefined : () => onSelect(item.id)}
            className={cn(
              "flex-1 flex items-center justify-center gap-1.5 px-2 py-2 md:py-2.5 rounded-lg text-xs md:text-sm font-semibold whitespace-nowrap transition-all duration-200",
              isActive
                ? "gradient-primary text-white shadow-lg shadow-brand/20"
                : "text-muted-foreground hover:text-foreground hover:bg-secondary"
            )}
          >
            <Icon className="w-4 h-4" />
            {item.label}
          </button>
        );
      })}
    </div>
  );
}
